export enum RouteLayout {
  DEFAULT = "default",
  BLANK = "blank",
}

export enum RouteName {
  PORTAL = "portal",
  SOC_TICKETS = "soc-tickets",
  MSP_SOC_TICKETS = "msp-soc-tickets",
  ENDPOINT_SECURITY_SETTINGS_PAGE = "endpoint-security-settings-page",
  ENDPOINT_SECURITY_DEVICE_POSTURE_TAB = "endpoint-security-device-posture-tab",
  ENDPOINT_SECURITY_DEVICE_POLICY_TAB = "endpoint-security-device-policy-tab",
  ENDPOINT_SECURITY_NGAV_TAB = "endpoint-security-ngav-tab",
  ENDPOINT_SECURITY_ALLOW_BLOCK_LIST_TAB = "endpoint-security-allow-block-list-tab",
  ENDPOINT_SECURITY_DEVICE_ADDONS_TAB = "endpoint-security-device-addons-tab",
  ENDPOINT_SECURITY_MALWARE_SCAN_TAB = "endpoint-security-malware-scan-tab",
  EDR_PAGE = "edr-page",
  EDR_PROCESSES_TAB = "edr-processes-tab",
  EDR_TELEMETRY_TAB = "edr-telemetry-tab",
  EDR_SETTINGS_TAB = "edr-settings-tab",
  EDR_ALLOW_BLOCK_LIST_TAB = "edr-allow-block-list-tab",
  PROCESS_GRAPH = "process-graph",
  ENDPOINT_DATA_GOVERNANCE_PAGE = "endpoint-data-governance-page",
  ENDPOINT_DATA_GOVERNANCE_PRIVACY_SENSITIVE_DATA_TAB = "endpoint-data-governance-privacy-sensitive-data-tab",
  ENDPOINT_DATA_GOVERNANCE_SENSITIVE_DATA_SCANS_TAB = "endpoint-data-governance-sensitive-data-scans-tab",
  ENDPOINT_DATA_GOVERNANCE_EXCLUSIONS_TAB = "endpoint-data-governance-exclusions-tab",
  ACCESS_CONTROL_PAGE = "access-control-page",
  ACCESS_CONTROL_ADMIN_USERS_TAB = "access-control-admin-users-tab",
  ACCESS_CONTROL_ROLES_TAB = "access-control-roles-tab",
  ACCESS_CONTROL_ACTIVE_SESSIONS_TAB = "access-control-active-sessions-tab",
  DEVICES_SETTINGS_PAGE = "devices-settings-page",
  DEVICES_SETTINGS_AGENT_DEPLOYMENT_TAB = "devices-settings-agent-deployment-tab",
  DEVICES_SETTINGS_DEVICE_SETTINGS_TAB = "devices-settings-device-settings-tab",
  DEVICES_SETTINGS_LABELS_TAB = "devices-settings-labels-tab",
  ACCESS_CONTROL_ADMIN_USER_DETAILS = "access-control-admin-user-details",
  CONNECTORS_PAGE = "connectors-page",
  CONNECTORS_SIEM_TAB = "connectors-siem-tab",
  CONNECTORS_API_KEYS_TAB = "connectors-api-keys-tab",
  CONNECTORS_WEBHOOKS_TAB = "connectors-webhooks-tab",
  CONNECTORS_PSA_TAB = "connectors-psa-tab",
  CONNECTORS_CONNECTWISE = "connectors-connectwise",
  CONNECTORS_SYSLOG = "connectors-syslog",
  CONNECTORS_CONNECTWISE_WORKSPACE_MAPPING = "connectors-connectwise-workspace-mapping",
  CONNECTORS_CONNECTWISE_SERVICE_MAPPING = "connectors-connectwise-service-mapping",
  CONNECTORS_CONNECTWISE_TICKETING = "connectwise-ticketing",
  CONNECTORS_AUTOTASK = "connectors-autotask",
  CONNECTORS_AUTOTASK_WORKSPACE_MAPPING = "connectors-autotask-workspace-mapping",
  CONNECTORS_AUTOTASK_SERVICE_MAPPING = "connectors-autotask-service-mapping",
  CONNECTORS_AUTOTASK_TICKETING = "connectors-autotask-ticketing",
  USER_DATA_GOVERNANCE_PAGE = "user-data-governance-page",
  USER_DATA_GOVERNANCE_MONITORING_TAB = "user-data-governance-monitoring-tab",
  USER_DATA_GOVERNANCE_PERMISSIONS_TAB = "user-data-governance-permissions-tab",
  USER_DATA_GOVERNANCE_EXCLUSIONS_TAB = "user-data-governance-exclusions-tab",
  EMAIL_SECURITY_PAGE = "email-security-page",
  EMAIL_SECURITY_SETTINGS_TAB = "email-security-settings-tab",
  EMAIL_SECURITY_ALLOW_BLOCK_LIST_TAB = "email-security-allow-block-list-tab",
  EMAIL_SECURITY_ADD_INS_TAB = "email-security-add-ins-tab",
  EMAIL_SECURITY_INBOUND_GATEWAY_TAB = "email-security-inbound-gateway-tab",
  EMAIL_SECURITY_CORO_MAIL_TAB = "email-security-coro-mail-tab",
  CLOUD_SECURITY_PAGE = "cloud-security-page",
  CLOUD_SECURITY_PERMISSIONS_LIST_TAB = "cloud-security-permissions-list-tab",
  CLOUD_SECURITY_THIRD_PARTY_APPS_TAB = "cloud-security-third-party-apps-tab",
  CLOUD_SECURITY_ACCESS_PERMISSIONS_PAGE = "cloud-security-access-permissions-page",
  CLOUD_SECURITY_SETTINGS = "cloud-security-settings",
  GATEWAY_SETTINGS_INBOUND = "inbound",
  GATEWAY_SETTINGS_OUTBOUND = "outbound",
  SETTINGS = "settings",
  ACTIVITY_LOGS = "activity-logs",
  DEVICES = "devices",
  PROTECTED_USERS = "protected-users",
  BACK_OFFICE_PAGE = "back-office-page",
  MSP_BACK_OFFICE_PAGE = "msp-back-office-page",
  BACKOFFICE_DASHBOARD = "backoffice-dashboard",
  MSP_BACKOFFICE_DASHBOARD = "msp-backoffice-dashboard",
  BACKOFFICE_PERMISSIONS_PAGE = "backoffice-permissions-page",
  MSP_BACKOFFICE_PERMISSIONS_PAGE = "msp-backoffice-permissions-page",
  GLOBAL_ADMIN_USERS = "global-admin-users",
  MSP_GLOBAL_ADMIN_USERS = "msp-global-admin-users",
  GLOBAL_ROLES = "global-roles",
  MSP_GLOBAL_ROLES = "msp-global-roles",
  BACK_OFFICE_AGENT_GRADUAL_UPDATE = "back-office-agent-gradual-update",
  BACK_OFFICE_DISCOVERY_STATS = "back-office-discovery-stats",
  BACK_OFFICE_GLOBAL_ALLOW_BLOCK_LIST = "back-office-global-allow-block-list",
  MSP_BACK_OFFICE_AGENT_GRADUAL_UPDATE = "msp-back-office-agent-gradual-update",
  MSP_BACK_OFFICE_DISCOVERY_STATS = "msp-back-office-discovery-stats",
  MSP_BACK_OFFICE_GLOBAL_ALLOW_BLOCK_LIST = "msp-back-office-global-allow-block-list",
  // TODO: uncomment in future when needed again
  // BACK_OFFICE_WORKSPACE_CODES = "back-office-workspace-codes",
  MSP = "msp",
  MSP_WORKSPACES_PAGE = "msp-workspaces-page",
  MSP_WORKSPACES_TREEVIEW_TAB = "msp-treeview-tab",
  MSP_WORKSPACES_LIST_TAB = "msp-workspaces-list-tab",
  MSP_ADMIN_USERS_TAB = "msp-admin-users-tab",
  MSP_ROLES_TAB = "msp-roles-tab",
  MSP_TICKETS_PAGE = "msp-tickets-page",
  MSP_DEVICES_PAGE = "msp-devices-page",
  MSP_DRIVES_TAB = "msp-drives-tab",
  MSP_DEVICES_TAB = "msp-devices-tab",
  MSP_PROTECTED_USERS_PAGE = "msp-protected-users-page",
  MSP_CONTROL_PANEL_PAGE = "msp-control-panel-page",
  MSP_ACCESS_CONTROL_PAGE = "msp-access-control-page",
  MSP_LABELS = "msp-labels-page",
  MSP_CLOUD_BACKUP = "msp-cloud-backup-page",
  MSP_GLOBAL_POLICIES = "msp-global-policies",
  MSP_REPORTS = "msp-reports-page",
  MSP_REPORTS_EXPORTS_TAB = "msp-reports-exports-tab",
  MSP_REPORTS_LIST_TAB = "msp-reports-list-tab",
  MSP_REPORTS_WARNING_ONLY_EMAIL_EVENTS_TAB = "msp-reports-warning-only-email-events-tab",
  MSP_ALLOW_BLOCK_LISTS = "msp-allow-block-lists",
  MSP_ALLOW_BLOCK_LISTS_EMAIL_SECURITY_TAB = "msp-allow-block-lists-email-security-tab",
  MSP_ALLOW_BLOCK_LISTS_ENDPOINT_SECURITY_TAB = "msp-allow-block-lists-endpoint-security-tab",
  MSP_ALLOW_BLOCK_LISTS_EDR_TAB = "msp-allow-block-lists-edr-tab",

  ALERTS = "alerts",
  SOC_PAGE = "soc-page",
  SOC_CONTACTS_TAB = "soc-contacts-tab",
  SOC_REMEDIATION_TAB = "soc-remediation-tab",
  USERS_SETTINGS_PAGE = "users-settings-page",
  USERS_SETTINGS_USERS_TAB = "users-settings-users-tab",
  USERS_SETTINGS_GROUPS_TAB = "users-settings-groups-tab",
  USERS_SETTINGS_EXCEPTIONS_TAB = "users-settings-exceptions-tab",
  USERS_SETTINGS_LABELS_TAB = "users-settings-labels-tab",
  NETWORK_PAGE = "network-page",
  NETWORK_OVERVIEW_TAB = "network-overview",
  NETWORK_VPN_TAB = "vpn-tab",
  ZTNA_TAB = "ztna-tab",
  SECURE_WEB_GATEWAY_SETTINGS = "secure-web-gateway",
  NETWORK_SITE_TO_SITE_TAB = "network-site-to-site",
  NETWORK_SETTINGS_TAB = "network-settings",
  NETWORK_VIRTUAL_OFFICE = "network-virtual-office",
  TICKETS = "tickets",
  MY_ACCOUNT_PAGE = "my-account-page",
  MY_ACCOUNT_PROFILE_TAB = "my-account-profile-tab",
  MY_ACCOUNT_CHANGE_PASSWORD_TAB = "my-account-change-password-tab",
  MY_ACCOUNT_MFA_TAB = "my-account-mfa-tab",
  MY_ACCOUNT_NOTIFICATIONS_TAB = "notifications",
  REPORTS_PAGE = "reports-page",
  REPORTS_SELECT_REPORTS = "reports-select-reports",
  REPORTS_EXPORTS_TAB = "reports-exports-tab",
  REPORTS_SCHEDULED_TAB = "reports-scheduled-tab",
  REPORTS_EXECUTIVE_SUMMARY_TAB = "reports-executive-summary-tab",
  REPORTS_DNS_SUMMARY_TAB = "reports-dns-summary-tab",
  REPORTS_MANAGED_SERVICES_SUMMARY_TAB = "reports-managed-services-summary-tab",
  REPORTS_SECURED_MESSAGES_SUMMARY_TAB = "reports-secured-messages-summary-tab",
  REPORTS_PHISHING_SIMULATION_SUMMARY_TAB = "reports-phishing-simulation-summary-tab",
  REPORTS_SECURITY_AWARENESS_TAB = "reports-security-awareness-tab",
  REPORTS_WARNING_ONLY_EMAIL_EVENTS_TAB = "reports-warning-only-email-events-tab",
  BILLING_PAGE = "billing-page",
  BILLING_SUBSCRIPTION_TAB = "billing-subscription-tab",
  CLOUD_APPS_PAGE = "cloud-apps-page",
  LOGIN = "login",
  OAUTH_CONSENT = "oauth-consent",
  MFA_PAGE = "mfa",
  MFA_VERIFICATION = "verification",
  ACTIVATE_MOBILE_PAGE = "activate-mobile",
  MDM_CALLBACK_PAGE = "mdm-callback-page",
  PROXY_VERIFICATION_PAGE = "proxy-verification-page",
  EMAIL_VERIFICATION_PAGE = "email-verification-page",
  PNI_VERIFICATION_PAGE = "pni-verification-page",
  SIGN_UP = "sign-up",
  WORKSPACES = "workspaces",
  FORGOT_PASSWORD = "forgot-password",
  RESET_PASSWORD = "reset-password",
  SECURITY_AWARENESS = "security-awareness",
  PHISHING_SIMULATION = "phishing-simulation",
  SECURITY_TRAINING = "security-training",
  SECURITY_AWARENESS_SETTINGS = "security-awareness-settings",
  /**
   * @deprecated
   */
  DOWNLOADS_PAGE = "downloads-page",
  INVITED_PAGE = "invited",
  SSO_PAGE = "sso",
  ABNORMAL_DATA_MANIPULATION_DETAILS_PAGE = "abnormal-data-manipulation-details-page",
  GLOBAL_WORKSPACE_MANAGEMENT_PAGE = "global-workspace-management-page",
  MSP_GLOBAL_WORKSPACE_MANAGEMENT_PAGE = "msp-global-workspace-management-page",
  DASHBOARD_PAGE = "dashboard-page",
  MSP_DASHBOARD_PAGE = "msp-dashboard-page",

  SECURITY_GAPS_PAGE = "security-gaps-page",
  MSP_SECURITY_GAPS_PAGE = "msp-security-gaps-page",

  GATEWAY_SETTINGS = "gateway",

  CORO_IMPACT_PAGE = "coro-impact-page",
  MSP_CORO_IMPACT_PAGE = "msp-coro-impact-page",

  NETWORK_SETTINGS_GENERAL = "network-general-settings",

  CLOUD_BACKUP_PAGE = "cloud-backup-page",
  CLOUD_BACKUP_OVERVIEW_TAB = "cloud-backup-overview-tab",
  CLOUD_BACKUP_BACKUPS_TAB = "cloud-backup-backup-tab",
  CLOUD_BACKUP_RESTORES_TAB = "cloud-backup-restore-tab",
  CLOUD_BACKUP_CONNECTED_APPS_TAB = "cloud-backup-connected-apps-tab",
}
